module.exports = __webpack_public_path__ + "h5/img/kefu.dadecf69.png";